module.exports = __webpack_public_path__ + "img/compang-logo.bffc0ac9.png";